import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import './style.css';
import Load from "../../../../../../components/load";

const Providers = ({ media_type, movie_id, movie_name }) => {

    const [providers, setProviders] = useState([]);
    const [countryProvider, setCountryProvider] = useState('BR');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (media_type && movie_id) {
            fetch(`https://api.themoviedb.org/3/${media_type}/${movie_id}/watch/providers?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`)
                .then(response => response.json())
                .then(data => {
                    setProviders(data.results);
                    console.log(data)
                });

            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    }, [media_type, movie_id]);

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [countryProvider]);

    const linkProviders = [
        { id: 2, link: 'https://tv.apple.com/search?term=' },
        { id: 350, link: 'https://tv.apple.com/br/search?term=' },
        { id: 3, link: 'https://play.google.com/store/search?q=', params: '&c=movies' },
        { id: 8, link: 'https://www.netflix.com/search?q=' },
        { id: 10, link: 'https://www.primevideo.com/search/ref=atv_nb_sug?ie=UTF8&phrase=' },
        { id: 119, link: 'https://www.primevideo.com/search/ref=atv_nb_sug?ie=UTF8&phrase=' },
        { id: 307, link: 'https://globoplay.globo.com/busca/?q=' },
        { id: 337, link: 'https://www.disneyplus.com/pt-br/search?q=' },
        { id: 619, link: 'https://www.starplus.com/pt-br/search?q=' },
        { id: 283, link: 'https://www.crunchyroll.com/search?q=' },
        { id: 478, link: 'https://history.uol.com.br/search/node?keys=' },
        { id: 1790, link: 'https://www.lionsgateplus.com/br/pt/search/' },
        { id: 68, link: media_type === 'tv' ? 'https://www.microsoft.com/pt-br/search/shop/tv?q=' : 'https://www.microsoft.com/pt-br/search/shop/movies?q=' },
        { id: 0, link: '' },
    ];

    const linkProvidersSearch = (id, providerName) => {
        const getLink = linkProviders.find(provider => provider.id === id);
        return getLink ? `${getLink.link}${movie_name}${getLink.params ? getLink.params : ''}` : `https://www.google.com/search?q=${providerName} ${movie_name}`;
    };

    const hasProviders = ['free', 'flatrate', 'buy', 'rent'].some(type => providers?.[countryProvider]?.[type]?.length > 0);

    return (
        <>
            {loading ? <Load align_center={true} /> :
                <div className="providers">
                    {hasProviders &&
                        <p className="description-about-providers">Assista <strong>{movie_name}</strong> em sua plataforma preferida!</p>
                    }
                    <div className="container-providers">
                        {['free', 'flatrate', 'buy', 'rent'].map(type => (
                            providers?.[countryProvider]?.[type]?.length > 0 && (
                                <div className="content-provider" key={type}>
                                    <h3>{type === 'free' ? 'Grátis' : type === 'flatrate' ? 'Assinatura' : type === 'buy' ? 'Comprar' : 'Alugar'}</h3>
                                    <Swiper
                                        slidesPerView={'auto'}
                                        spaceBetween={10}
                                        freeMode={false}
                                        pagination={{ clickable: true }}
                                    >
                                        {providers[countryProvider][type].map((provider, key) => (
                                            <SwiperSlide key={key}>
                                                <a className="provider" href={`${linkProvidersSearch(provider.provider_id, provider.provider_name)}`} target="_blank" rel="noopener noreferrer">
                                                    <img src={`https://image.tmdb.org/t/p/original${provider.logo_path}`} alt="Provider Logo" />
                                                </a>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )
                        ))}
                        {!hasProviders && <p className="description-about-providers"><i className="fas fa-triangle-exclamation"></i> Não encontramos nenhuma plataforma!</p>}
                    </div>
                </div>
            }
        </>
    );
};

export default Providers;
